export const USE_CLIENT_NCC_STATE_SWITCH_NAME = 'charge_ncd_fees_based_on_client_ncd_status_100423';
